import request from "../request";

export const getElements = (curriculumId) =>
  request.get(`curriculum/${curriculumId}/element`).then((res) => res);

export const getElementChildrenById = (curriculumId, childrenId) =>
  request.get(`curriculum/${curriculumId}/element/children/${childrenId}`).then((res) => res);
  
export const createElementChildren = (curriculumId, data) =>
  request.post(`curriculum/${curriculumId}/element/children`, data).then((res) => res);

export const updateBasicInformationElementChildren = (curriculumId, childrenId, data) =>
  request.put(`curriculum/${curriculumId}/element/children/${childrenId}/basic-information`, data).then((res) => res);

export const updateElementsElementStructureId = (curriculumId, type, childrenId, data) =>
  request.put(`curriculum/${curriculumId}/element/children/${childrenId}/elements/structure/${type}`, data).then((res) => res);

export const updateTypeElementsElementChildren = (curriculumId, type, childrenId, data) =>
  request.put(`curriculum/${curriculumId}/element/children/${childrenId}/elements/${type}`, data).then((res) => res);

export const deleteElementChildren = (curriculumId, childrenId) =>
  request.delete(`curriculum/${curriculumId}/element/children/${childrenId}`).then((res) => res);
